export default __webpack_public_path__ + "static/media/book13.a774fa8b.svg";